import { render, staticRenderFns } from "./AssignClassroom.vue?vue&type=template&id=0bf07be0&scoped=true"
import script from "./AssignClassroom.vue?vue&type=script&lang=js"
export * from "./AssignClassroom.vue?vue&type=script&lang=js"
import style0 from "./AssignClassroom.vue?vue&type=style&index=0&id=0bf07be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf07be0",
  null
  
)

export default component.exports